import { render, staticRenderFns } from "./CoursePeriodsType.vue?vue&type=template&id=1d585ec9"
import script from "./CoursePeriodsType.vue?vue&type=script&lang=js"
export * from "./CoursePeriodsType.vue?vue&type=script&lang=js"
import style0 from "./CoursePeriodsType.vue?vue&type=style&index=0&id=1d585ec9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports